



















import {Vue, Component, Watch} from 'vue-property-decorator';
import _ from 'underscore'
import PrivacyList from './staticPrivacy';
interface PrivacyItem {
  ver : string,
  contents: string
}
@Component
export default class FooterServicePrivacy extends Vue {
  private currentPrivacy:PrivacyItem;
  private created(){
    const version = this.$route.query.ver as string;
    if(version){
      this.currentPrivacy = _.findWhere(PrivacyList as PrivacyItem[], {ver: version});
    }else{
      this.currentPrivacy = PrivacyList[PrivacyList.length - 1]as PrivacyItem;
    }
  }
  @Watch ('$route.query')
  private onVersionChanged(){
    const version = this.$route.query.ver as string;
    if(version){
      this.currentPrivacy = _.findWhere(PrivacyList as PrivacyItem[], {ver: version});
    }else{
      this.currentPrivacy = PrivacyList[PrivacyList.length - 1]as PrivacyItem;
    }
    this.$forceUpdate();
  }
  private hasPrev(){
    const currentIndex = _.findIndex(PrivacyList, {ver: this.currentPrivacy.ver as string});
    return currentIndex > 0;
  }
  private hasNext(){
    const currentIndex = _.findIndex(PrivacyList, {ver: this.currentPrivacy.ver as string});
    return currentIndex < PrivacyList.length -1;
  }
  private onClickPrevNext(moveType) {
    const currentIndex = _.findIndex(PrivacyList, {ver: this.currentPrivacy.ver as string});
    const nextPrivacy = moveType === 'prev' ? PrivacyList[currentIndex - 1] : PrivacyList[currentIndex + 1];
    this.$router.replace({ query: {ver: nextPrivacy.ver} }).catch(() => null);
    window.scrollTo(0, 0);
  }
}
